import { render, staticRenderFns } from "./EmoteWallWidgetPreview.vue?vue&type=template&id=453b42ce"
import script from "./EmoteWallWidgetPreview.vue?vue&type=script&lang=js"
export * from "./EmoteWallWidgetPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports